// Must be mapped in Vercel to make it public
const SHA = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? 'unknown';

const APP_IDENTIFIER = `WEB:${SHA}`;

export default APP_IDENTIFIER;
